/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".access-denied-page-sec[_ngcontent-%COMP%]{display:-ms-flexbox;display:flex;height:100vh;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-direction:column;flex-direction:column}.access-denied-page-sec[_ngcontent-%COMP%]   .headerCls[_ngcontent-%COMP%]{color:#636262;font-size:1.7rem;font-weight:700;line-height:2.1rem;margin:2.5rem 0 2rem}"];
export { styles as styles };



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/logout/logout.component.css.shim.ngstyle.js.pre-build-optimizer.js